"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormTerminosYCondiciones = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _TyCSiro = _interopRequireDefault(require("./TyCSiro.js"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class FormTerminosYCondiciones extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleChangeCheck = this.handleChangeCheck.bind(this);
  }

  handleChangeCheck(event) {
    this.props.onChange(event.target.checked, event.target.name);
  }

  render() {
    const {
      aceptaTerminosYCondiciones,
      es_siro
    } = this.props;
    return (0, _react2.jsx)(_material.Box, {
      mt: 2
    }, (0, _react2.jsx)(_material.Box, {
      mb: 2,
      mt: 2
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, "T\xE9rminos y Condiciones")), es_siro ? (0, _react2.jsx)(_TyCSiro.default, {
      classes: _style.default
    }) : null //despues agregar aca los tyc de sic
    , (0, _react2.jsx)(_material.Grid, {
      css: _style.default.checkTyc
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      control: (0, _react2.jsx)(_material.Checkbox, {
        color: "primary",
        checked: aceptaTerminosYCondiciones,
        onChange: this.handleChangeCheck,
        name: "aceptaTerminosYCondiciones"
      }),
      label: "Aceptar Terminos y Condiciones"
    })));
  }

}

exports.FormTerminosYCondiciones = FormTerminosYCondiciones;
var _default = FormTerminosYCondiciones;
exports.default = _default;